import { createTheme, ThemeProvider } from '@mui/material/styles';

export const URLMAIN_STATIC = "http://septerra.duckdns.org:44444";
export const URLMAIN_API = "http://septerra.duckdns.org:44444/api";

export const theme = createTheme({
  palette: {
    // mode:"dark",
    primary: {
      main: '#2f524e',
    },
    background: {
      paper: '#e8e8de',
      default: '#e8e8de',
    },
    secondary: {
      main: '#2f524e',
    },
    info: {
      main: '#48808f',
    },
  },
});